module.exports = __webpack_public_path__ + "img/national_center_for_performing_arts.35f9566a.png";